import { StepperStep, ColorClasses } from '@/shared/types/stepper';
import { StepStatus } from '@/shared/types/types';
import { StepIcon } from '../atoms/StepIcon';
import { StepLabel } from '../atoms/StepLabel';
import { StepConnector } from '../atoms/StepConnector';

interface StepItemProps {
  step: StepperStep;
  stepIndex: number;
  status: StepStatus;
  colorClasses: ColorClasses;
  isLast: boolean;
  onStepClick: (stepIndex: number) => void;
  classNameStep?: string;
  classNameStepLabel?: string;
  classNameStepIcon?: string;
  classNameStepNumber?: string;
  vertical?: boolean;
  stepClickable?: boolean;
  white?: boolean;
}

/**
 * StepItem - Contenedor de cada paso individual
 *
 * En horizontal, cada celda puede encogerse hasta ~87.5px de ancho para que una fila de cuatro pasos
 * quepa en contenedores de ~350px (icono 38px preservado; líneas conectoras escalan con el flex).
 */
export const StepItem = ({
  step,
  stepIndex,
  status,
  colorClasses,
  isLast,
  onStepClick,
  classNameStep = '',
  classNameStepLabel = '',
  classNameStepIcon = '',
  classNameStepNumber = '',
  vertical = false,
  stepClickable = false,
  white = false,
}: StepItemProps) => {
  const containerClasses = !vertical
    ? 'ui-flex ui-min-w-[87.5px] ui-basis-0 ui-flex-1 ui-items-center ui-place-self-start'
    : 'ui-flex ui-flex-col ui-items-center ui-h-[60px] ui-min-h-[60px] ui-place-self-start';

  const stepClasses = !vertical
    ? 'ui-flex ui-flex-col ui-items-center ui-cursor-pointer ui-relative ui-w-full ui-gap-y-16'
    : 'ui-flex ui-flex-row ui-items-center ui-cursor-pointer ui-relative ui-h-full ui-gap-x-16';

  return (
    <div className={containerClasses}>
      <div
        className={`${stepClasses} ${classNameStep}`}
        onClick={() => stepClickable && onStepClick(stepIndex)}
      >
        <StepIcon
          stepIndex={stepIndex}
          status={status}
          colorClasses={colorClasses}
          className={classNameStepIcon}
          classNameNumber={classNameStepNumber}
        />

        <StepLabel
          step={step}
          stepIndex={stepIndex}
          className={classNameStepLabel}
          vertical={vertical}
          white={white}
        />

        {!isLast && <StepConnector colorClasses={colorClasses} vertical={vertical} />}
      </div>
    </div>
  );
};
